import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams, useHistory } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '@iarcpsu/emanufac-components/src/components/Button';
import {
  PurchaseOrderForm,
  EditMaterialInPurhaseOrderForm,
} from '@iarcpsu/emanufac-components/src/components/Forms';
import { Loading } from '@iarcpsu/emanufac-components/src/components/Loading';
import { Error } from '@iarcpsu/emanufac-components/src/components/Error';
import { ViewTitle } from '@iarcpsu/emanufac-components/src/components/ViewTitle';

const defaultValues = {
  material: '',
  remark: '',
  bill_number: '',
  // payment: '',
  supplier: '',
  source: '',
};

export default function EditPurchaseOrder({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const material = useSelector((state) => state.material);
  const customer = useSelector((state) => state.customer);
  // const paymentType = useSelector((state) => state.paymentType);
  const purchaseOrder = useSelector((state) => state.purchaseOrder);
  const history = useHistory();
  const [selectMaterial, setSelectMaterial] = useState([]);
  const [name] = useState('');
  const [page] = useState(1);
  const [size] = useState(5);
  const {
    formState: { errors },
    handleSubmit,
    control,
    reset,
  } = useForm();

  useEffect(() => {
    dispatch(actions.purchaseOrderGet(id));
    dispatch(actions.materialAll({ name: '', size: '', page: 1 }));
    dispatch(actions.customerAll({ name: '', size: '', page: 1 }));
    // dispatch(actions.paymentTypeAll({ name: '', size: '', page: 1 }));
    dispatch(actions.meGet(''));
    return () => {};
  }, [name, page, size]);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data, event) => {
    try {
      data.material = selectMaterial;
      event.preventDefault();
      await dispatch(actions.purchaseOrderPut(id, data));
      dispatch(actions.purchaseOrderAll({ name: '', size: '', page: 1 }));
      reset(defaultValues);
      alert('สำเร็จ');
      history.goBack();
    } catch (error) {
      console.log(error);
    }
  };
  const renderForm = () => (
    <Card className="p-4">
      <div>
        <PurchaseOrderForm
          Controller={Controller}
          control={control}
          errors={errors}
          customer={customer.rows}
          // paymentType={paymentType.rows}
          purchaseOrder={purchaseOrder}
        />
      </div>
    </Card>
  );

  const renderSelectMaterial = () => (
    <Card>
      <EditMaterialInPurhaseOrderForm
        material={material.rows}
        setSelectMaterial={setSelectMaterial}
        purchaseOrder={purchaseOrder}
      />
    </Card>
  );
  if (purchaseOrder.isLoading || purchaseOrder.rows) {
    return <Loading />;
  }
  if (!purchaseOrder.isLoading && purchaseOrder.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-row flex-wrap">
              <div className="w-full lg:w-1/3 px-1 py-2">{renderForm()}</div>
              <div className="w-full lg:w-2/3 px-1 py-2">
                {renderSelectMaterial()}
              </div>
            </div>
            <div className="flex flex-row justify-end gap-1 py-4">
              <Button variant="contained" type="submit">
                บันทึก
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
  return <Error />;
}

EditPurchaseOrder.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditPurchaseOrder.defaultProps = {
  title: '',
  subtitle: '',
};
